import { action } from 'easy-peasy';
import { IActionSetInfo } from '../types';

const setInfo: IActionSetInfo = action((state, payload) => {
  state.info = payload;
});

export default setInfo;
